<template>
  <div class="container keyword-ranking-report">
<!--    <div class="keyword-ranking-report__title-container">-->
<!--      <div v-if="isDataFetched" class="keyword-ranking-report__title-right">-->
<!--        <div class="keyword-ranking-report__export-button"-->
<!--             @click="exportCsv">-->
<!--          <base-material-design-icon icon="download"/>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="keyword-ranking-report__advanced_wrapper">
      <advanced-filters v-if="isDataFetched"
        class="keyword-ranking-report__advanced"
        :options="advancedOptions" 
        :predefinedOptions="_advancedFilters" 
        copyPage
        exportEnabled
        @share="copyFilters" 
        @export="exportCsv"
        @apply-advanced="applyAdvancedOptions" />
    </div>

    <div class="container" style="margin-top: 14px; padding: 0;" v-if="snapshotsMissing">
      <div class="keyword-ranking-report__no-data">Looks like you don’t have any ranking data to report.</div>
    </div>

    <div class="" v-else-if="!isDataFetched">
      <div class="keyword-ranking-report__loader">
        <base-loader/>
      </div>
    </div>
    <template v-else>
      <div class="keyword-ranking-report__keyword-filter">
        <span class="keyword-ranking-report__keyword-filter_label">Keyword</span>
        <base-select
           alignLeft
           borderLess
           isRotation
           :options="keywordFilterOptions"
           :selectStyle="{ width: '151px' }"
           v-model="filterParams.keyword.operator"
        />
        <div class="keyword-ranking-report__keyword-filter_input-container">
          <input
            v-model="keywordFilter"
            :style="{
              paddingRight: keywordFilter ? '19px' : '27px',
              width: keywordFilter ? '300px' : '292px'
            }"
            class="keyword-ranking-report__keyword-filter_input"
            type="text"
          />
          <div
            v-if="keywordFilter"
            class="keyword-ranking-report__keyword-filter_clear-button"
            @click.stop="filterParams.keyword.value = ''"></div>
          <base-material-design-icon
            v-else
            class="keyword-ranking-report__keyword-filter_search-button"
            icon="search"
          />
        </div>
      </div>
      <div class="common-table keyword-ranking-report__table">
        <div class="common-table__date_selection common-table__row">
          <base-radio class="common-table__radio"
                      v-for="(item, index) in changeTypeConfig"
                      :label="item.label"
                      :key="item.value"
                      :style="{'margin-left': (index === 0 ? 15 : -5) + 'px'}"
                      v-model="filterParams.changeProgressType"
                      :value="item.value" />
          <base-select
            class="keyword-ranking-report__web-property"
            style="margin-left: 9px"
            truncateLabel
            :titleStyle="{color: '#011627', paddingLeft: '15px'}"
            :options="webPropertyGroups"
            v-model="webPropertyGroupId"
            showTopBorder
            :propListStyle="{ maxHeight: '360px', maxWidth: '200px' }"
            placeholder="Web Property" />

          <base-select
            class="keyword-ranking-report__grid-select"
            style="margin-left: auto;"
            :options="paginationOptions"
            alignLeft
            :titleStyle="{'padding-left': '5px'}"
            :headerStyle="{}"
            showTopBorder
            shiftLabelRight
            v-model="pageItemsLimit"
            @change="handleLimitChange"
          />
        </div>
        <div class="common-table__row common-table__header">
          <div class="common-table__header-cell"
               v-for="column in keywordRankingReportTableHeaders"
               :key="column.property"
               :class="[`keyword-ranking-report__${column.property}`]">
            <base-multi-select-sortable-header
              v-if="!['change', 'keyword'].includes(column.property)"
              class="keyword-ranking-report__select-header"
              :column="column"
              :sort-config="sortConfig"
              :predefinedOptions="filterParams[column.property]"
              :predefinedNumberFilter="!['keyword', 'snapshot_1_rank', 'snapshot_2_rank'].includes(column.property)
                ? filterParams[column.property]
                : null"
              @sort="onSortingCellClicked(column, $event)"
              @apply="filterColumn($event, column)"
              :ref="sortableHeaderRefs[column.property]"
            />
            <base-table-sortable-column
              v-else
              class="keyword-ranking-report__sortable-header"
              :class="[`keyword-ranking-report__sortable-header_${column.property}`]"
              :label="column.label"
              :prop-name="column.property"
              :sort-config="sortConfig"
              @click.native="onHeaderCellClicked(column)"
            />
            <base-select v-if="column.property === 'snapshot_1_rank'"
                         class="keyword-ranking-report__select keyword-ranking-report__date-picker"
                         v-model="selectedSnapshots.snapshot_date_1"
                         showTopBorder
                         :options="formatedSnapshots"/>
            <base-select v-if="column.property === 'snapshot_2_rank'"
                         class="keyword-ranking-report__select keyword-ranking-report__date-picker"
                         v-model="selectedSnapshots.snapshot_date_2"
                         showTopBorder
                         :options="formatedSnapshots"/>
          </div>
        </div>
        <template v-if="dataMissing">
          <div class="common-table__row no-data-block">
            No records found
          </div>
        </template>
        <template v-else>
          <template v-for="keyword in sortedKeywords">
            <div :key="keyword._id" class="common-table__row">
              <div class="common-table__cell"
                   v-for="column in keywordRankingReportTableHeaders"
                   :key="column.property"
                   :class="[`keyword-ranking-report__${column.property}`, `keyword-ranking-report__row_${column.property}`]">
                <template v-if="column.property === 'keyword'">
                  <base-search-in-google class="keyword-ranking-report__row_keyword__search" :query="keyword.keyword" />
                  <span @click.stop="openModal(keyword.keyword)">{{keyword.keyword}}</span>
                </template>
                <template v-else-if="column.property === 'change'">
                <span :class="[`keyword-ranking-report__${keyword.change_type}`]">
                  {{getChangeValue(keyword.change, keyword.change_type)}}
<!--                    <base-material-design-icon-->
<!--                      v-if="['uptrend', 'downtrend'].includes(keyword.change_type)"-->
<!--                      style="font-size: 17px"-->
<!--                      :icon="keyword.change_type === 'uptrend' ? 'rankRice' : 'rankDecline'"/>-->
                </span>
                </template>
                <template v-else>
                  {{keyword[column.property]}}
                </template>
              </div>
            </div>
          </template>
        </template>
      </div>
    </template>
    <div class="pagination-wrapper" v-show="hasPagination">
      <base-pagination :limit="pageItemsLimit"
                       :total-items="totalItems"
                       @pageChanged="pageChanged"/>
    </div>
    <div class="keyword-ranking-report__update-loader" v-if="isDataUpdating">
      <base-loader class="keyword-ranking-report__update-loader-ring"/>
    </div>
    <modal name="history" v-bind="modalProps">
      <base-keyword-history-modal :comparison="comparisonArray"
                                  :predefinedWebPropertyGroupId="predefinedWebPropertyGroupId"
                                  :predefinedSelectedRankZones="predefinedSelectedRankZones"
                                  :isFilter="isKeywordMovementFilter"
                                  :keyword="selectedKeyword"
                                  @close="closeModal"/>
    </modal>
  </div>
</template>

<script>
import _ from 'lodash'
import baseModalProps from '@/common/BaseModalProps'
import ToasterService from '@/services/toasterService'
import AdvancedFilters from '@/features/reports/common/advanced-filters/AdvancedFilters'
import csvExport from '@/services/CSVExport'
import { advancedFiltersMixins } from '@/features/reports/common/AdvancedFiltersMixins'
import BaseSortMixins from '@/common/BaseSortMixins'
import moment from 'moment'
import filters from '@/common/Filters'
import helper from '@/services/Helper'
import { mapState, mapActions } from 'vuex'
import { baseComponent } from '@/features/reports/common/Mixins'
import {
  addOptionsToConfig,
  ADVANCED_OPTION_TYPE,
  convertAdvancedOptionsToFilters,
  keywordRankingReportFieldsConfig
} from '@/features/reports/common/advanced-options/config'

const changeTypeConfig = [
  {
    label: 'All',
    value: 'all'
  },
  {
    label: 'New',
    value: 'new'
  },
  {
    label: 'Lost',
    value: 'lost'
  },
  {
    label: 'Uptrend',
    value: 'uptrend'
  },
  {
    label: 'Downtrend',
    value: 'downtrend'
  }
]
const RANKING_SNAPSHOT_OPTIONS = [
  {
    label: '01 - 03', // label
    value: '1,3'
  },
  {
    label: '04 - 07',
    value: '4,7'
  },
  {
    label: '08 - 10',
    value: '8,10'
  },
  {
    label: '11 - 25',
    value: '11,25'
  },
  {
    label: '26 - 50',
    value: '26,50'
  },
  {
    label: '51 - 100',
    value: '51,100'
  },
  {
    label: 'NR',
    value: 'NR'
  },
  {
    label: 'ND',
    value: 'ND'
  }
]
const KEYWORD_FILTER_VALUE_ENUMS = {
  Exactly: 'em',
  Containing: 'con',
  Begins: 'bw',
  Ends: 'ew'
}
const KEYWORD_FILTER_OPTIONS = [
  {
    value: KEYWORD_FILTER_VALUE_ENUMS.Exactly,
    label: 'Exactly matching'
  },
  {
    value: KEYWORD_FILTER_VALUE_ENUMS.Containing,
    label: 'Containing'
  },
  {
    value: KEYWORD_FILTER_VALUE_ENUMS.Begins,
    label: 'Begins with'
  },
  {
    value: KEYWORD_FILTER_VALUE_ENUMS.Ends,
    label: 'Ends with'
  }
]
const DEFAULT_CONFIG = [
  {
    label: 'Keyword',
    property: 'keyword',
    propName: 'keyword',
    isSmartInput: true // this property activates BaseMultiSelectFilterDropdown in BaseMultiSelectSortableHeader
  },
  {
    label: 'MSV',
    property: 'msv',
    isNumber: true,
    isClearOnCross: true, // clear filter on click on cross icon
    isSmartInput: false
  },
  {
    label: 'Rel Score',
    property: 'score',
    isNumber: true,
    isClearOnCross: true,
    isSmartInput: false
  },
  {
    label: 'Diff Score',
    property: 'diff_score',
    isNumber: true,
    isClearOnCross: true,
    isSmartInput: false
  },
  {
    header_label: 'Ranking on',
    label: '',
    property: 'snapshot_1_rank',
    isSelectableValue: true, // this value could be selected using BaseSelect widget
    isSmartInput: false,
    options: RANKING_SNAPSHOT_OPTIONS
  },
  {
    header_label: 'Ranking on',
    label: '',
    property: 'snapshot_2_rank',
    isSelectableValue: true, // this value could be selected using BaseSelect widget
    isSmartInput: false,
    options: RANKING_SNAPSHOT_OPTIONS
  },
  {
    label: 'Change',
    property: 'change',
    propName: 'change'
    // isNumber: true,
    // isClearOnCross: true,
    // isSmartInput: false,
    // advancedFilterDefault: 1
  }
]
const EMPTY_FILTERS = {
  baseline_rank: [],
  change: {
    operator: null,
    value: null
  },
  snapshot_1_rank: [],
  snapshot_2_rank: [],
  score: {
    operator: null,
    value: null
  },
  diff_score: {
    operator: null,
    value: null
  },
  msv: {
    operator: null,
    value: null
  },
  changeProgressType: 'all',
  keyword: {
    operator: 'con',
    value: ''
  },
  page_from: 0,
  page_to: 100
}
export default {
  name: 'KeywordRankingReport',
  filters: {
    ...filters
  },
  components: { AdvancedFilters },
  mixins: [advancedFiltersMixins, BaseSortMixins, baseComponent],
  // filters received form url
  props: ['filters', 'modal'],
  data () {
    return {
      isDataFetched: false,
      isDataUpdating: false,
      isKeywordMovementFilter: false,
      selectedAdvancedOptions: [],
      tempComparisonArray: [],
      webPropertyGroupId: null,
      predefinedSelectedRankZones: {},
      predefinedWebPropertyGroupId: null,
      webPropertyGroupIdClientId: null,
      isExportCSV: false,
      pageItemsLimit: 100,
      // eslint-disable-next-line vue/no-reserved-keys
      _advancedFilters: [],
      unpaginatedKeywords: [],
      totalItems: 0,
      sortConfig: [{
        sortDirection: helper.DIRECTION_DESC,
        propertyName: 'change'
      }],
      changeTypeConfig,
      selectedSnapshots: {
        snapshot_date_1: null,
        snapshot_date_2: null
      },
      sortableHeaderRefs: {
        'keyword': 'keyword',
        'msv': 'msv',
        'score': 'score',
        'diff_score': 'diff_score',
        'snapshot_1_rank': 'snapshot_1_rank',
        'snapshot_2_rank': 'snapshot_2_rank',
        'change': 'change',
        'baseline_rank': 'baseline_rank'
      },
      // flag notifies that filters received form url query was applied
      isQueryFiltersApplied: false,
      isQueryModalApplied: false,
      filterParams: _.cloneDeep(EMPTY_FILTERS),
      keywordFilterOptions: _.cloneDeep(KEYWORD_FILTER_OPTIONS),
      keywordFilter: '',
      keywordFilterTimer: null,
      selectedKeyword: '',
      paginationOptions: [
        {
          label: '100',
          value: 100
        },
        {
          label: '250',
          value: 250
        },
        {
          label: '500',
          value: 500
        }
      ]
    }
  },
  destroyed () {
    this.resetKeywordsList()
  },
  watch: {
    selectedSnapshots: {
      handler (value) {
        this.isDataFetched && this.loadData()
      },
      deep: true,
      immediate: true
    },
    snapshots: {
      handler (value) {
        if (value.length) {
          this.selectedSnapshots.snapshot_date_1 = value[0]
          this.selectedSnapshots.snapshot_date_2 = value[1] ? value[1] : value[0]
        }
      },
      deep: true,
      immediate: true
    },
    'filterParams.keyword.value': {
      handler (v) {
        this.keywordFilter = v
      },
      immediate: true
    },
    keywordFilter (v) {
      clearTimeout(this.keywordFilterTimer)
      this.keywordFilterTimer = setTimeout(() => {
        this.filterParams.keyword.value = v
      }, 1000)
    },
    webPropertyGroups: {
      handler (groups) {
        if (groups.length) {
          /* set default webPropertyGroup */
          this.webPropertyGroupId = groups[0].value
        }
      },
      deep: true,
      immediate: true
    },
    webPropertyGroupId: {
      handler (v) {
        this.webPropertyGroupIdClientId = this.clientId
        v && this.loadData()
      },
      immediate: true
    },
    filterParams: {
      handler () {
        this.isDataFetched && (this.isDataUpdating = true)
      },
      deep: true
    }
  },
  computed: {
    ...mapState('rankZoneCommon', {
      /**
       * modify advanced options config {@link #urlFieldsConfig}
       * by received form backend client specific data
       * */
      advancedOptions: (state) => {
        let config = _.cloneDeep(keywordRankingReportFieldsConfig)
        addOptionsToConfig(config, state.sections, ADVANCED_OPTION_TYPE.SECTION)
        addOptionsToConfig(config, state.attributes, ADVANCED_OPTION_TYPE.ATTRIBUTE)
        addOptionsToConfig(config, state.urlStatuses, ADVANCED_OPTION_TYPE.URL_STATUS)
        addOptionsToConfig(config, state.pageTypes, ADVANCED_OPTION_TYPE.PAGE_TYPE)
        addOptionsToConfig(config, state.scores, ADVANCED_OPTION_TYPE.SCORE)
        addOptionsToConfig(config, state.isOptimized, ADVANCED_OPTION_TYPE.IS_OPTIMIZED)
        addOptionsToConfig(config, state.urlAttributes, ADVANCED_OPTION_TYPE.URL_ATTRIBUTE)
        addOptionsToConfig(config, state.serpFeature, ADVANCED_OPTION_TYPE.SERP_FEATURE)
        addOptionsToConfig(config, state.contentBriefStatuses, ADVANCED_OPTION_TYPE.CONTENT_BRIEF_STATUS)
        addOptionsToConfig(config, state.mismatchedUrls, ADVANCED_OPTION_TYPE.MISMATCHED_URLS)
        addOptionsToConfig(config, state.mappedUrls, ADVANCED_OPTION_TYPE.URL)
        return state.difficultyScoreEnabled ? config : config.filter(i => i.type !== ADVANCED_OPTION_TYPE.DIFF_SCORE)
      },
      /* prepare webPropertyGroup for dropdown */
      webPropertyGroups (state) {
        return _.cloneDeep(state.webPropertyGroups).sort((a, b) => {
          if ((a.type === 'Clients' && b.type === 'Siblings') || (a.type === 'Siblings' && b.type === 'Competitors')) {
            return -1
          } else if ((b.type === 'Clients' && a.type === 'Siblings') || (b.type === 'Siblings' && a.type === 'Competitors')) {
            return 1
          } else {
            return 0
          }
        }).map(item => {
          return {
            value: item._id,
            label: item.label,
            type: item.type,
            style: {
              color: item.type === 'Siblings' ? '#284aff' : '#011627',
              fontWeight: item.type === 'Clients' ? 'bold' : 'normal'
            },
            attributes: item.type === 'Clients' ? [{ 'private-content': true }] : [],
          }
        }) || []
      },
      snapshots: 'snapshots'
    }),
    ...mapState('keywordRankingReport', ['keywords']),
    dataMissing () {
      const isDataMissing = !this.keywords.length
      if (isDataMissing) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.totalItems = 0
      }
      return isDataMissing
    },
    keywordRankingReportTableHeaders () {
      const defaultConfig = _.cloneDeep(DEFAULT_CONFIG)
      defaultConfig.find(i => i.property === 'snapshot_1_rank').label = this.selectedSnapshots.snapshot_date_1
      defaultConfig.find(i => i.property === 'snapshot_2_rank').label = this.selectedSnapshots.snapshot_date_2
      return !this.isClientDifficultyScoreEnabled ? defaultConfig.filter(i => i.property !== 'diff_score') : defaultConfig
    },
    comparisonArray () {
      return this.tempComparisonArray.length ? this.tempComparisonArray : (this.webPropertyGroups.find(i => i.value === this.webPropertyGroupId) || {}).type === 'Clients' ? [] : [this.webPropertyGroupId]
    },
    hasPagination () {
      return (this.isDataFetched && !this.isDataUpdating) && this.totalItems > this.pageItemsLimit
    },
    sortedKeywords () {
      let keywords = _.cloneDeep(this.keywords)
      const filterParams = _.cloneDeep(this.filterParams)
      const numbersCells = ['msv', 'score', 'diff_score', 'change', 'baseline_rank']
      const filterSnapshotsByRankZone = (filterParams, filter, item) => {
        return filterParams[filter].some(value => {
          const mappedValue = value && !['ND', 'NR'].includes(value) ? value.split(',') : value
          return Array.isArray(mappedValue)
            ? item[filter] >= parseInt(mappedValue[0]) && item[filter] <= parseInt(mappedValue[1])
            : mappedValue === item[filter]
        })
      }
      keywords = keywords.filter(item => {
        let keywordFilter
        if (!filterParams.keyword.value) {
          keywordFilter = true
        } else {
          let value = filterParams.keyword.value.toLowerCase()
          let keyword = item.keyword.toLowerCase()
          let filter
          switch (filterParams.keyword.operator) {
            case KEYWORD_FILTER_VALUE_ENUMS.Exactly:
              filter = keyword === value
              break
            case KEYWORD_FILTER_VALUE_ENUMS.Containing:
              filter = keyword.includes(value)
              break
            case KEYWORD_FILTER_VALUE_ENUMS.Begins:
              filter = keyword.startsWith(value)
              break
            case KEYWORD_FILTER_VALUE_ENUMS.Ends:
              filter = keyword.endsWith(value)
              break
          }
          keywordFilter = filter
        }

        const changeProgressType = filterParams.changeProgressType === 'all' ? true : item.change_type === filterParams.changeProgressType

        const cellNumberFilter = numbersCells.map((cell) => {
          if (
            (!filterParams[cell].operator) ||
            (filterParams[cell].operator === 'equal' && filterParams[cell].value === item[cell]) ||
            (filterParams[cell].operator === 'ne' && filterParams[cell].value !== item[cell]) ||
            (filterParams[cell].operator === 'gt' && filterParams[cell].value < item[cell]) ||
            (filterParams[cell].operator === 'lt' && filterParams[cell].value > item[cell]) ||
            (filterParams[cell].operator === 'lte' && filterParams[cell].value >= item[cell]) ||
            (filterParams[cell].operator === 'gte' && filterParams[cell].value <= item[cell])
          ) {
            return true
          } else {
            return false
          }
        })

        const snapshot1Rank = !filterParams.snapshot_1_rank.length
          ? true
          : filterSnapshotsByRankZone(filterParams, 'snapshot_1_rank', item)

        const snapshot2Rank = !filterParams.snapshot_2_rank.length
          ? true
          : filterSnapshotsByRankZone(filterParams, 'snapshot_2_rank', item)

        const baselineRank = !filterParams.baseline_rank.length
          ? true
          : filterSnapshotsByRankZone(filterParams, 'baseline_rank', item)

        return keywordFilter && !cellNumberFilter.includes(false) &&
          snapshot1Rank && snapshot2Rank && changeProgressType && baselineRank
      })
      // sorting
      if (this.sortConfig.length && filterParams.changeProgressType === 'all' && this.sortConfig[0].propertyName === 'change') {
        keywords = this.sortAll(keywords, this.sortConfig)
      } else {
        keywords = helper.sortByMultipleParams(keywords, this.sortConfig)
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.totalItems = keywords.length
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.unpaginatedKeywords = keywords
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.isDataUpdating = false
      return keywords.slice(this.filterParams.page_from, this.filterParams.page_to)
    },
    formatedSnapshots () {
      return this.snapshots.map(snapshot => {
        return {
          label: this.$options.filters.formattedDate(snapshot),
          value: snapshot
        }
      })
    },
    modalProps () {
      const shareModalProps = {
        width: '75%'
      }
      return { ...baseModalProps, ...shareModalProps }
    }
  },
  methods: {
    ...mapActions('keywordRankingReport', ['loadKeywordsData', 'resetKeywordsList']),
    ...mapActions('rankZoneKeywordMovementHistory', ['getKeywordHistoryModal']),
    async loadData () {
      if (this.isDataFetched) {
        this.isDataUpdating = true
      }
      if (!this.isQueryFiltersApplied) {
        this.setupFilterParams()
      }
      if (!this.isQueryModalApplied) {
        await this.setupModalParams()
      }
      const advancedFilters = convertAdvancedOptionsToFilters(this.selectedAdvancedOptions)
      await this.loadKeywordsData({
        clientId: this.clientId,
        filters: {
          webPropertyGroupId: this.webPropertyGroupId,
          snapshot_date_1: this.selectedSnapshots.snapshot_date_1,
          snapshot_date_2: this.selectedSnapshots.snapshot_date_2,
          advancedFilters
        }
      })
      this.isDataUpdating = false
      this.isDataFetched = true
    },
    async setupModalParams () {
      let modal = null
      try {
        if (this.modal) {
          modal = await this.getKeywordHistoryModal({ clientId: this.clientId, viewId: this.modal })
        } else {
          return
        }
      } catch {
        this.isQueryModalApplied = true
        return
      }
      const clientId = modal.clientId
      // we need to change client, return false
      if (clientId !== this.clientId) {
        if (!this.setNewClient(clientId, true)) {
          // user does not allowed to see this client, filters will be ignored
          console.warn(this.$route.name + ' client with id ', clientId, 'does not connected to current user')
          this.isQueryModalApplied = true
        }
        return
      }
      this.predefinedWebPropertyGroupId = modal.webPropertyGroupId
      this.predefinedSelectedRankZones = modal.selectedRankZones
      this.tempComparisonArray = modal.tempComparisonArray
      this.selectedKeyword = modal.keyword
      this.isKeywordMovementFilter = true
      this.$modal.show('history')
      this.isQueryModalApplied = true
    },
    /**
     * method restores filterParams from url query filters and notifies about possibility to load page data
     * in this case all logic will be repeated again after changing client
     */
    setupFilterParams () {
      let filters = null
      try {
        filters = JSON.parse(this.filters)
      } catch (e) {
        return
      }
      const clientId = filters.client_id
      const emptyUrlFilters = !Object.values(filters).some(item => item)
      if (emptyUrlFilters || this.isQueryFiltersApplied || !clientId) {
        return
      }
      // we need to change client, return false
      if (clientId !== this.clientId) {
        if (!this.setNewClient(clientId, true)) {
          // user does not allowed to see this client, filters will be ignored
          console.warn(this.$route.name + ' client with id ', clientId, 'does not connected to current user')
          this.isQueryFiltersApplied = true
          // this.filterParams = { ...this.filterParams, ..._.cloneDeep(EMPTY_FILTERS) }
        }
        return
      }
      // there is exactly the same client selected
      try {
        if (filters.filters.length) {
          this.advancedFilters = JSON.stringify({filters: filters.filters, client_id: filters.client_id});
          this.restoreAdvancedFilters();
        }
      } catch (e) {
        console.error('Error to set advanced filters')
      }
      try {
        if (filters.filterParams) {
          this.filterParams = Object.assign({}, EMPTY_FILTERS, filters.filterParams)
        }
      } catch (e) {
        console.error('Error to set filter params filters')
      }
      try {
        if (filters.sortConfig) {
          this.sortConfig = [...filters.sortConfig]
        }
      } catch (e) {
        console.error('Error to set sort config')
      }
      try {
        if (filters.pageItemsLimit) {
          this.handleLimitChange(filters.pageItemsLimit)
        }
      } catch (e) {
        console.error('Error to set page items limit')
      }
      this.isQueryFiltersApplied = true
    },
    copyFilters () {
      let path = `${window.location.origin}${window.location.pathname}#${this.$route.path}?filters=`
      const copiedAdvancedFilters = []
      this.selectedAdvancedOptions.forEach(item => {
        copiedAdvancedFilters.push({
          selectedField: item.selectedField,
          selectedFilter: item.selectedFilter,
          selectedOperator: item.selectedOperator
        })
      })
      const copiedFilters = {
        client_id: this.clientId,
        filters: copiedAdvancedFilters,
        filterParams: {},
        sortConfig: this.sortConfig,
        pageItemsLimit: this.pageItemsLimit
      }
      Object.entries(this.filterParams).forEach(([key, value]) => {
        if (_.isObject(value) && Object.values(value).some(item => item)) {
          copiedFilters.filterParams[key] = _.cloneDeep(value)
        }
        if (_.isInteger(value) || (_.isString(value) && Boolean(value))) {
          copiedFilters.filterParams[key] = value
        }
      })
      path += JSON.stringify(copiedFilters)
      path = encodeURI(path)
      this.$copyText(path)
        .then(
          e => {
            ToasterService.showToast(ToasterService.INFO_TYPE, 'Filters copied to clipboard')
          },
          // eslint-disable-next-line handle-callback-err
          err => {
            ToasterService.showToast(ToasterService.ERROR_TYPE, 'Can not copy filters')
          }
        )
    },
    /**
     * changes number of paginated items in teh list
     * */
    handleLimitChange: function (value) {
      this.pageItemsLimit = value
      this.filterParams = { ...this.filterParams, page_from: 0, page_to: value }
    },
    /**
     * Change sort direction for column (asc/desc)
     */
    onSortingCellClicked (column, direction) {
      this.isDataUpdating = true
      if (direction === 'clear') {
        this.sortConfig.shift()
        return
      }
      if (this.sortConfig.length) {
        this.sortConfig[0].propertyName = column.property
        this.sortConfig[0].sortDirection = direction
        // this.sortConfig[0].sortZeroToTheEnd = column.property === 'change'
      } else {
        this.sortConfig = [{
          sortDirection: direction,
          propertyName: column.property
          // sortZeroToTheEnd: column.property === 'change'
        }]
      }
    },
    async applyAdvancedOptions (options) {
      this.selectedAdvancedOptions = _.cloneDeep(options)
      if (this.webPropertyGroupIdClientId === this.clientId) this.loadData()
    },
    /**
     * Select filters for column
     * then {@link #loadFilteredData()} load data with filters
     */
    filterColumn (event, column) {
      if (['keyword', 'snapshot_1_rank', 'snapshot_2_rank', 'baseline_rank'].includes(column.property)) {
        this.filterParams = {
          ...this.filterParams,
          [column.property]: event
        }
      } else {
        this.filterParams = {
          ...this.filterParams,
          [column.property]: {
            operator: event.operator,
            value: Number(event.value)
          }
        }
      }
    },
    /**
     * Change page of URLs (pagination changes)
     */
    pageChanged ({ from, to }) {
      this.filterParams.page_from = from
      this.filterParams.page_to = to
    },
    async exportCsv () {
      this.isExportCSV = true
      const getRankZone = (rank) => {
        switch (true) {
          case ['NR', 'ND'].includes(rank):
            return rank
          case rank <= 3:
            return '01 to 03'
          case rank <= 7:
            return '04 to 07'
          case rank <= 10:
            return '08 to 10'
          case rank <= 25:
            return '11 to 25'
          case rank <= 50:
            return '26 to 50'
          case rank <= 100:
            return '51 to 100'
          default:
            return 'NR'
        }
      }
      const rankZones = {
        'snapshot_1_rank_zone': 'snapshot_1_rank',
        'snapshot_2_rank_zone': 'snapshot_2_rank',
        'baseline_rank_zone': 'baseline_rank'
      }
      const handler = (columns) => {
        return item => {
          const row = []
          columns.forEach(name => {
            if (['snapshot_1_rank_zone', 'snapshot_2_rank_zone', 'baseline_rank_zone'].includes(name)) {
              const field = rankZones[name]
              row.push(getRankZone(item[field]))
            } else if (name === 'content_brief_id') {
              row.push(`"${window.location.origin}/dashboard#/content-briefs/${item.content_brief_id}/${item.url_status.toLowerCase() === 'published' ? 'progress' : 'strategy'}"`)
            } else if (name === 'change') {
              row.push(this.getChangeValue(item.change, item.change_type))
            } else if (['comparison_url', 'baseline_url'].includes(name)) {
              row.push(`"${item[name] ? item[name] : 'NR'}"`)
            } else if (name === 'diff_score') {
              row.push(`"${item[name] || 0}"`)
            } else {
              row.push(`"${item[name]}"`)
            }
          })
          data.push(row)
        }
      }

      const header = ['"Keyword"', '"Relevancy Score"', '"Monthly Searches"',
        `"Rank Date ${moment(this.selectedSnapshots.snapshot_date_1).format('YYYY/MM/DD')}"`,
        `"Rank Date ${moment(this.selectedSnapshots.snapshot_date_2).format('YYYY/MM/DD')}"`, '"Change"',
        '"Baseline Rank"', `"Ranking URL ${moment(this.selectedSnapshots.snapshot_date_1).format('YYYY/MM/DD')}"`,
        `"Rank Zone ${moment(this.selectedSnapshots.snapshot_date_1).format('YYYY/MM/DD')}"`,
        `"Ranking URL ${moment(this.selectedSnapshots.snapshot_date_2).format('YYYY/MM/DD')}"`,
        `"Rank Zone ${moment(this.selectedSnapshots.snapshot_date_2).format('YYYY/MM/DD')}"`,
        '"Baseline Ranking URL"', '"Baseline Rank Zone"', '"Baseline Rank Date"', '"Current Mapped URL"',
        '"Mapped URL Status"', '"Mapped URL Content Brief"']
      const columnNames = ['keyword', 'score', 'msv', 'snapshot_1_rank', 'snapshot_2_rank', 'change', 'baseline_rank',
        'snapshot_1_url', 'snapshot_1_rank_zone', 'snapshot_2_url', 'snapshot_2_rank_zone', 'baseline_url',
        'baseline_rank_zone', 'baseline_date', 'mapped_url', 'url_status', 'content_brief_id']

      if (this.isClientDifficultyScoreEnabled) {
        const index = columnNames.indexOf('score') + 1
        header.splice(index, 0, '"Diff Score"')
        columnNames.splice(index, 0, 'diff_score')
      }

      const data = []
      data.push(header)

      const keywords = _.cloneDeep(this.unpaginatedKeywords)
      keywords.forEach(handler(columnNames))
      csvExport(`${this.selectedClient.name.replace(/ /g, '-')}_Keywords-Rank-Report_${moment().format('YYYY-MM-DD')}`, data)
      this.isExportCSV = false
    },
    /**
     * Opens BaseKeywordMovementHistoryModal
     * @param keyword
     */
    openModal (keyword) {
      this.selectedKeyword = keyword
      this.$modal.show('history')
    },
    closeModal () {
      this.selectedKeyword = ''
      this.tempComparisonArray = []
      this.predefinedWebPropertyGroupId = null
      this.isKeywordMovementFilter = false
      this.$modal.hide('history')
    },
    getChangeValue (value, type) {
      if (type === 'new') {
        return 'New'
      } else if (type === 'lost') {
        return 'Lost'
      } else if (value === 0) {
        return 'No change'
      }
      return value
    },
    /**
     * sorting method when selected All && Change column
     * @param keyword
     * @param config
     * @returns {*[]}
     */
    sortAll (keyword, config) {
      const uptrendDowntrendNoChange = []
      const lostNew = []
      const noRankingNoData = []
      keyword.forEach(item => {
        if (['downtrend', 'uptrend'].includes(item.change_type) || item.change === 0) {
          uptrendDowntrendNoChange.push(item)
        } else if (['lost', 'new'].includes(item.change_type)) {
          lostNew.push(item)
        } else {
          noRankingNoData.push(item)
        }
      })

      const direction = config[0].sortDirection === helper.DIRECTION_ASC ? 1 : -1
      const sortFn = (a, b) => {
        return a.change > b.change ? 1 * direction : a.change < b.change ? -1 * direction : 0
      }
      uptrendDowntrendNoChange.sort(sortFn)
      lostNew.sort(sortFn)
      noRankingNoData.sort((a, b) => {
        const value1 = a.change
        const value2 = b.change
        if (value1 === value2) {
          return 0
        } else if (value1 === null || value1 === 'ND' || (value1 === 'NR' && value2 !== 'ND')) {
          return 1
        } else {
          return -1
        }
      })

      if (direction === 1) {
        return [...lostNew, ...uptrendDowntrendNoChange, ...noRankingNoData]
      } else {
        return [...uptrendDowntrendNoChange, ...lostNew, ...noRankingNoData]
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .common-table {
    border-radius: 4px;
    overflow-x: scroll;
    min-height: 550px;
    background-color: $rfx-background-color;

    &::-webkit-scrollbar {
      visibility: hidden;
    }

    &__no-data {
      display: flex;
      height: 300px;
      background-color: #fff;
      border-radius: $rfx-default-border-radius;
      align-items: center;
      justify-content: center;
      font-size: 27px;
      font-weight: 600;
      color: $rfx-medium-grey;
    }

    &__row {
      background-color: #fff;
      border-left: 1px solid $rfx-light-steel;
      border-right: 1px solid $rfx-light-steel;

      &:last-child {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
      }
    }

    & > div {
      &:last-child {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }

    &__header {
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
    }

    &__radio {
      margin-right: 15px;
      cursor: pointer;

      &::v-deep .radio__label {
        font-size: 14px;
        font-weight: normal;
      }
    }

    &__header-cell {
      background-color: rgba(1,22,39,.1);
      font-weight: bold;
      padding: 0;
      height: 60px;
      display: flex;
      align-items: center;
      cursor: pointer;

      &:first-child {
        border-left: 1px solid $rfx-light-steel;

        &::v-deep .multi-select__title-container{
          padding-left: 6.6%;
        }
      }

      &:last-child {
        border-right: 1px solid $rfx-light-steel;
      }
    }

    &__date_selection {
      border-top: 1px solid $rfx-light-steel;
      padding: 10px 0;
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
    }

    &__cell {
      height: 60px;
      padding: 0;
      display: flex;
      align-items: center;
      font-size: 14px;
      border-bottom: 1px solid $rfx-light-steel;
    }
  }

  .keyword-ranking-report {
    position: relative;
    min-height: 200vh !important;

    &__date-picker {
      position: absolute !important;
      top: 11px;
      margin-left: 13px;

      &::v-deep .select__selection {
        font-weight: normal;
      }
    }

    &__keyword-filter {
      display: flex;
      align-items: center;
      padding-left: 24px;
      margin-bottom: 14px;

      &_label {
        font-size: 14px;
        font-weight: bold;
        margin-right: 14px;
      }

      &_input-container {
        position: relative;
        display: flex;
        margin-left: 12px;
      }

      &_input {
        border: none;
        border-bottom: 1px solid $rfx-bright-blue;
        height: 20px;
        background-color: transparent;
        flex: 1 1 100%;
        padding: 8px 0 8px 8px;
        outline: none;
      }

      &_clear-button,
      &_search-button {
        position: absolute;
        top: 13px;
        right: 8px;
        width: 16px;
        height: 16px;
        background-color: transparent;
        color: $rfx-dark-march;
      }

      &_clear-button {
        top: 10px;
        right: 2px;
      }

      &_clear-button {
        cursor: pointer;
        &:hover {
          opacity: 1;
        }

        &:before, &:after {
          position: absolute;
          left: 7px;
          top: 3px;
          content: '';
          height: 12px;
          width: 2px;
          background-color: currentColor;
        }

        &:before {
          transform: rotate(45deg);
        }

        &:after {
          transform: rotate(-45deg);
        }
      }
    }

    &__sortable-header {
      font-size: 14px;
      font-weight: 700;
      width: -webkit-fill-available;
      height: -webkit-fill-available;

      &_change {
        padding-left: 14px;
      }
    }

    &__web-property {
      width: 200px;
      margin-right: 36px;
    }

    &__title-container {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    /*&__all,*/
    /*&__new,*/
    /*&__lost,*/
    /*&__uptrend,*/
    /*&__downtrend {*/
      /*width: 100%;*/
      /*padding: 5px 12px;*/
      /*border-radius: 15px;*/
      /*color: white;*/
      /*min-width: 70px;*/
      /*text-align: center;*/
    /*}*/

    &__all {
      /*background-color: $rfx-brownish-grey;*/
      color: $rfx-brownish-grey;
    }

    &__new,
    &__uptrend {
      /*background-color: $rfx-green;*/
      color: $rfx-green;
    }

    &__downtrend,
    &__lost {
      color: $rfx-red;
      /*background-color: $rfx-red;*/
    }

    &__title-left {
      display: flex;
      align-items: center;
    }

    &__title-left > *:not(:last-child) {
      margin-right: 30px;
    }

    &__title-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex: 1 1 50%;
      margin-top: 1rem;
    }

    &__title-right > *:not(:last-child) {
      margin-right: 30px;
    }

    &__grid-select {
      width: 100px;
      margin-right: 25px;
    }

    &__loader {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      height: calc(100vh - 530px);
    }

    &__no-data {
      display: flex;
      height: 300px;
      background-color: #fff;
      border-radius: $rfx-default-border-radius;
      align-items: center;
      justify-content: center;
      font-size: 27px;
      font-weight: 600;
      color: $rfx-medium-grey;
      flex: 1 1;
    }

    &__table {
      position: relative;
      display: flex;
      flex-direction: column;
    }

    &__update-loader {
      position: absolute;
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      background-color: white;
      top: 0;
      opacity: 0.5;
      z-index: 10000;
    }

    &__update-loader-ring {
      margin-top: 200px;
    }

    &__baseline_rank,
    &__change,
    &__snapshot_1_rank,
    &__snapshot_2_rank,
    &__score,
    &__diff_score,
    &__msv {
      min-width: 127px;
      flex: 0 0 11.6%;
      color: $rfx-dark-march;
    }

    &__baseline_rank {
      flex-basis: 12.8%;
    }

    &__change,
    &__score,
    &__diff_score,
    &__msv {
      flex-basis: 8.8%;
    }

    &__change {
      padding-right: 16px;
    }

    &__row_keyword {
      padding-left: 2.4% !important;
      flex: 1 1;

      span {
        font-weight: 500;

        &:hover {
          cursor: pointer;
          color: $rfx-bright-blue !important;
          text-decoration: underline;
        }
      }

      &__search {
        position: static !important;
        margin-top: 5px !important;
        padding-left: 0 !important;
        padding-right: 15px;
      }
    }

    &__row_baseline_rank,
    &__row_change,
    &__row_snapshot_1_rank,
    &__row_snapshot_2_rank,
    &__row_score,
    &__row_diff_score,
    &__row_msv {
      color: $rfx-light-march;
      flex: 0 0 11.7%;
    }

    &__row_change,
    &__row_diff_score,
    &__row_score,
    &__row_msv {
      flex-basis: 8.8%;
    }

    &__row_change {
      color: $rfx-dark-march;
      padding-right: 0 !important;
    }

    &__keyword {
      color: $rfx-dark-march;

      &.common-table__header-cell {
        flex: 1 1;
        padding-left: 2.4%;
      }
    }

    &__select {
      width: 160px;
      color: $rfx-dark-march;
    }

    &__advanced {
      margin-top: 30px;
      margin-bottom: 14px;

      &::v-deep .collapsible__header {
        padding-right: 70px !important;
      }

      &::v-deep .collapsible__arrow {
        right: 46px !important;
      }
    }

    &__export-button {
      color: $rfx-bright-blue;
      position: absolute;
      right: 50px;
      top: 20px;
      z-index: 9;
      cursor: pointer;
      font-size: 20px;

      &_disabled {
        cursor: default;
        pointer-events: none;
        opacity: .4;
      }
    }
  }

  .no-data-block {
    border-bottom: 1px solid $rfx-light-steel;
  }

  .pagination-wrapper {
    display: flex;
    height: 60px;
    margin-top: 10px;
    justify-content: center;
    align-items: center;
    border: 1px solid $rfx-light-steel;
    border-radius: 4px;
  }
</style>
